import React from 'react';
import { CustomerTable } from 'components';
export const Customers = () => <CustomerTable />